import { render, staticRenderFns } from "./editApplyRoomDiscountRecord.vue?vue&type=template&id=96df77e0&scoped=true"
import script from "./editApplyRoomDiscountRecord.vue?vue&type=script&lang=js"
export * from "./editApplyRoomDiscountRecord.vue?vue&type=script&lang=js"
import style0 from "./editApplyRoomDiscountRecord.vue?vue&type=style&index=0&id=96df77e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96df77e0",
  null
  
)

export default component.exports